module.exports = __webpack_public_path__ + "img/shilaohuagaizao.8fd9f1cd.png";